export default class PackageRateProduction {
  constructor(data = {}) {
    this.setData(data);
  }

  setData(data = this.__data__) {
    this.id = data.id || undefined;
    this.hotelId = data.hotelId || undefined;
    this.roomTypeIds = data.roomTypeIds || [];
    this.ratePlan = data.ratePlan || {};
    this.bookablePackageRates = data.bookablePackageRates || [];
    this.ratePlanUpSell = data.ratePlanUpSell || [];
    this.name = data.name || undefined;
    this.imageLink = data.imageLink || undefined;
    this.amenityId = data.amenityId || undefined;
    this.calculationRule = data.calculationRule || undefined;
    this.postingRhythm = data.postingRhythm || undefined;
  }

  export() {
    const result = {
      id: this.id,
      hotelId: this.hotelId,
      roomTypeIds: this.roomTypeIds,
      ratePlan: Object.keys(this.ratePlan || {}).length ? this.ratePlan : undefined,
      bookablePackageRates: this.bookablePackageRates,
      ratePlanUpSell: this.ratePlanUpSell
    };

    return result;
  }
}
